/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrOrgAuthProvider } from './irrOrgAuthProvider';


export interface IrrSendGridConfig { 
    authProvider?: IrrOrgAuthProvider;
    account?: string;
    accountNumber?: string;
    functionUrl?: string;
    poolId?: string;
    providerId?: string;
    providerServiceAccount?: string;
}
export namespace IrrSendGridConfig {
}


